import React, { useState } from "react";
import { Helmet } from "react-helmet";

function SeminarHall() {
  const [activeTab, setActiveTab] = useState("aryabhaat");

  const halls = {
    aryabhaat: {
      name: "Aryabhaat Seminar Hall",
      description: "A well-equipped, air-conditioned seminar hall with state-of-the-art audio-visual systems, perfect for technical seminars and guest lectures.",
      images: [
        "/Images/Campus/placeholder.jpg",
        "/Images/Campus/placeholder.jpg",
        "/Images/Campus/placeholder.jpg"
      ]
    },
    radhakrishnan: {
      name: "Radha Krishnan Hall",
      description: "A spacious hall designed for workshops, academic conferences, and cultural events, featuring ergonomic seating and advanced projection facilities.",
      images: [
        "/Images/Campus/placeholder.jpg",
        "/Images/Campus/placeholder.jpg",
        "/Images/Campus/placeholder.jpg"
      ]
    }
  };

  return (
    <>
      <Helmet>
        <title>Seminar Halls - VBU MCA</title>
      </Helmet>
      <div className="PageContainer">
        <div id="Heading">
          <h1>Seminar Halls</h1>
        </div>

        <div className="SeminarHallSection" data-aos="fade-up">
          <p className="SeminarIntro">
            Our campus features specialized seminar halls designed to facilitate high-level academic discourse, presentations, and interactive workshops.
          </p>

          <div className="HallTabs">
            <button 
              className={activeTab === "aryabhaat" ? "activeTab" : ""} 
              onClick={() => setActiveTab("aryabhaat")}
            >
              Aryabhaat Hall
            </button>
            <button 
              className={activeTab === "radhakrishnan" ? "activeTab" : ""} 
              onClick={() => setActiveTab("radhakrishnan")}
            >
              Radha Krishnan Hall
            </button>
          </div>

          <div className="HallDetails" key={activeTab} data-aos="fade-in">
            <div className="HallInfo">
              <h2>{halls[activeTab].name}</h2>
              <p>{halls[activeTab].description}</p>
            </div>
            
            <div className="HallGallery">
              {halls[activeTab].images.map((img, idx) => (
                <div key={idx} className="HallImageCard">
                  <img src={img} alt={`${halls[activeTab].name} ${idx + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .SeminarHallSection {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          gap: 30px;
        }
        .SeminarIntro {
          text-align: center;
          font-size: 1.15rem;
          color: #666;
          max-width: 800px;
          margin: 0 auto 20px auto;
          line-height: 1.6;
        }
        .HallTabs {
          display: flex;
          justify-content: center;
          gap: 20px;
          border-bottom: 2px solid #eee;
          padding-bottom: 10px;
        }
        .HallTabs button {
          border: none;
          background: none;
          padding: 12px 30px;
          font-size: 1.1rem;
          font-weight: 600;
          color: #777;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
        }
        .HallTabs button.activeTab {
          color: #1a237e;
        }
        .HallTabs button.activeTab::after {
          content: '';
          position: absolute;
          bottom: -12px;
          left: 0;
          width: 100%;
          height: 3px;
          background: #1a237e;
        }
        .HallDetails {
          padding-top: 20px;
        }
        .HallInfo {
          text-align: center;
          margin-bottom: 40px;
        }
        .HallInfo h2 {
          color: #1a237e;
          font-size: 2rem;
          margin-bottom: 15px;
        }
        .HallInfo p {
          color: #555;
          font-size: 1.1rem;
          max-width: 900px;
          margin: 0 auto;
        }
        .HallGallery {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 25px;
        }
        .HallImageCard {
          overflow: hidden;
          border-radius: 12px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.1);
          height: 250px;
        }
        .HallImageCard img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }
        .HallImageCard:hover img {
          transform: scale(1.1);
        }
        @media (max-width: 768px) {
          .HallTabs {
            flex-direction: column;
            align-items: center;
            gap: 10px;
          }
          .HallInfo h2 {
            font-size: 1.6rem;
          }
        }
      `}</style>
    </>
  );
}

export default SeminarHall;
